import { ClaimToolAssociatedImagePayload } from "./claim-tool-associated-image";
import { AddedReferencePhrasesPayload } from "./added-reference-phrases-payload";
import { SplitPhrase } from "./split-phrase.model";
import { ClaimToolAssociatedTextPayload } from "./claim-tool-associated-phrase";

export class ClaimToolSaveChangesModel {
    
    run_num: number;
    doc_id: number;
    phrase_id: number;
    associated_text: ClaimToolAssociatedTextPayload[];
    deleted_associated_text: number[];
    associated_images: ClaimToolAssociatedImagePayload[];
    deleted_associated_images: number[];
    is_precheck: boolean;
    references: AddedReferencePhrasesPayload[];
    deleted_references: number[];
    phrase_content_type: string;
    merged_phrases: number[];
    phrases_order: number[];
    split_phrases: SplitPhrase[];
    phrase_type_code: string;
    phrase_sub_type_code: string;

}